<template>
    <div class="misc-wrapper">
        <b-link class="brand-logo">
            <b-img id="top-bar-logo" :src="`${staticAssetEndpoint}/images/logos/saysimple-dark.svg`" center />
        </b-link>

        <div class="misc-inner p-2 p-sm-3">
            <div class="w-100 text-center">
                <h2 class="mb-1">{{ $t("not-authorized") }}</h2>
                <p class="mb-2">{{ $t("no-permission") }}</p>
                <div class="mb-1">
                    <b-button :to="{ path: '/' }" class="mr-1 btn-sm-block" variant="primary">
                        {{ $t("back-to-home") }}
                    </b-button>

                    <b-button class="btn-sm-block" variant="primary" @click="logout">
                        {{ $t("logout") }}
                    </b-button>
                </div>

                <b-img :src="imgUrl" alt="Not authorized page" fluid />
            </div>
        </div>
    </div>
</template>

<script>
import { BLink, BImg, BButton } from "bootstrap-vue";
import store from "@/store/index";

export default {
    components: {
        BLink,
        BImg,
        BButton,
    },
    data() {
        return {
            downImg: require("@/assets/images/pages/not-authorized.svg"),
            staticAssetEndpoint: process.env.VUE_APP_MFE_STATIC_ENDPOINT,
        };
    },
    computed: {
        imgUrl() {
            if (store.state.appConfig.layout.skin === "dark") {
                this.downImg = require("@/assets/images/pages/not-authorized-dark.svg");
                return this.downImg;
            }
            return this.downImg;
        },
    },
    methods: {
        logout() {
            this.$auth.logout({
                returnTo: window.location.origin,
            });
        },
    },
};
</script>

<style lang="scss">
@import "~@core/scss/vue/pages/page-misc.scss";
</style>
